export default __webpack_public_path__ + "static/media/tantrabase.f3bac61d.png";